<template>
  <div class="create_image">
    <div v-if="problemList.length > 0" class="dia_problem">
      <div class="flex-y-c mb10">
        <img
            alt=""
            class="mr10"
            src="../../../common/imgs/case/dia_warn_cion.png"
            style="width: 24px"
        />
        <h5>{{ $t("cases.createImage.czrxwt") }}</h5>
      </div>
      <div class="pro_box">
        <span
            v-for="(item, index) in problemList"
            :key="`${item.id}_${index}`"
            class="curp"
            @click="jumpLocation(item.groupName)"
        >
          {{ item.groupName }}
        </span>
      </div>
    </div>
    <div
        :id="disposeId('牙颌模型')"
        :class="{ mt30: problemList.length > 0 }"
        class="image_single mt30"
    >
      <div class="image_single_header">
        <span class="vertical_line"></span>
        <p class="fz18 main_theme_color_333 mr10">
          {{ $t("cases.createImage.yemx") }}
          <span class="main_theme_color_red mt12 fz14">●</span>
        </p>
        <img
            alt=""
            class="dib mr4"
            src="../../../common/imgs/case/creater_img_ask.png"
            style="width: 12px"
        />
        <router-link
            :to="{ name: 'helpCenter', query: { type: '11' } }"
            style="display: flex; align-items: center"
            target="_blank"
        >
          <span class="main_theme_color fz14 curp">
            {{ $t("cases.createImage.mxzqbz") }}
          </span>
        </router-link>
      </div>
      <div class="single_con">
        <p v-if="diagnosisProblem['牙颌模型']" class="problem_note">
          {{ diagnosisProblem['牙颌模型'] }}
        </p>
        <div class="s_c_box">
          <div
              :style="language === 'en_US' ? 'width: 1.5rem' : ''"
              class="s_c__left"
          >
            {{ $t("cases.createImage.gxjmx") }}
          </div>
          <div class="s_c__right">
            <div
                class="s_c__r_box"
                @click.stop="
                ev => {
                  selectedProblem(ev, 'siliconeRubberModel');
                }
              "
            >
              <template
                  v-for="(item, index) in dictObj['silicone_rubber_model']"
              >
                <span
                    v-if="showModel(item.key)"
                    :key="`${item.key}_${index}0`"
                    :class="{
                    s_c__sp_active:
                      diagnosisParams.siliconeRubberModel === item.key,
                    disabled_btn: modeNoProblem,
                    not_allowed: modeNoProblem,
                    disabled_btn_two:
                      modeNoProblem &&
                      diagnosisParams.siliconeRubberModel === item.key
                  }"
                    :data-key="item.key"
                    class="s_c__sp"
                >{{ item.value }}</span
                >
              </template>

              <p class="main_theme_color_red fz14" style="margin-left: 10px">
                {{ $t("common.common.shxh") }}
              </p>
            </div>
            <p
                v-show="
                diagnosisParams.siliconeRubberModel === 'silicagel_print_model'
              "
                class="mt20 fz14 main_theme_color_666 mb10"
            >
              {{ $t("cases.createImage.yscblh") }}
            </p>
            <div
                v-show="
                diagnosisParams.siliconeRubberModel === 'silicagel_print_model'
              "
                :style="language === 'en_US' ? 'width: 5.5rem' : ''"
                class="s_c__tip flex-y-c"
            >
              <p
                  :class="{ mr20: language === 'en_US' }"
                  class="main_theme_color_333 fz14"
              >
                {{ $t("cases.createImage.blxh") }}
              </p>
              <input
                  id="casesNumber"
                  :value="caseNumber"
                  class="main_theme_color_333 fz14"
                  readonly
                  style="width: 0.8rem"
              />
              <div
                  ref="copyCases"
                  class="tip_sp_icon ml40"
                  data-clipboard-action="copy"
                  data-clipboard-target="#casesNumber"
                  @click="copyCasesNumber"
              ></div>
              <p
                  :style="language === 'en_US' ? 'width: 1.8rem' : ''"
                  class="s_c_fkd"
                  @click="sendExpress"
              >
                <span class="fkd_icon"></span>
                <span
                    :class="{
                    not_allowed: modeNoProblem
                  }"
                    class="fz14 ml10 main_theme_color_333"
                >{{ $t("cases.createImage.fkd") }}</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="s_c_box">
          <div
              :style="language === 'en_US' ? 'width: 1.5rem' : ''"
              class="s_c__left"
          >
            {{ $t("cases.createImage.szmxwz") }}
          </div>
          <div class="s_c__right">
            <div
                class="s_c__r_box"
                @click.stop="
                ev => {
                  selectedProblem(ev, 'digitalModelFile');
                }
              "
            >
              <span
                  v-for="(item, index) in dictObj['digital_model_file']"
                  :key="`${item.key}_${index}1`"
                  :class="{
                  s_c__sp_active: diagnosisParams.digitalModelFile === item.key,
                  disabled_btn: modeNoProblem,
                  not_allowed: modeNoProblem,
                  disabled_btn_two:
                    modeNoProblem &&
                    diagnosisParams.digitalModelFile === item.key
                }"
                  :data-key="item.key"
                  class="s_c__sp"
              >{{ item.value }}</span
              >
            </div>
            <div v-show="diagnosisParams.digitalModelFile === 'local_upload'">
              <div class="s_c__up">
                <span
                    :style="language === 'en_US' ? 'width: 1.1rem' : ''"
                    class="fz14 main_theme_color_666"
                >
                  {{ $t("cases.createImage.se") }}
                </span>
                <el-upload
                    ref="sharpUpJaw"
                    :action="UPLOAD_URL"
                    :before-upload="
                    file =>
                      beforeFileUpload(
                        file,
                        'sharp_upjaw',
                        'stl',
                        'local_upload'
                      )
                  "
                    :data="{ token: uploadToken }"
                    :disabled="modeNoProblem"
                    :show-file-list="false"
                    class="upload-file flex-y-c"
                    drag
                >
                  <img
                      alt=""
                      class="dib ml40"
                      src="../../../common/imgs/case/create_img_upload_icon.png"
                      style="width: 24px; position: relative; top: 6px"
                  />
                  <span
                      :class="{
                      not_allowed: modeNoProblem,
                      disabled_btn: modeNoProblem
                    }"
                      class="up_load main_theme_color_999 fz14"
                  >{{ $t("cases.createImage.scstl") }}</span
                  >
                </el-upload>
                <p v-show="fileNameObj['sharp_upjaw']" class="up_file">
                  {{ fileNameObj["sharp_upjaw"] }}
                  <span class="up_status el-icon-success"></span>
                </p>
              </div>
              <div class="s_c__up">
                <span
                    :style="language === 'en_US' ? 'width: 1.1rem' : ''"
                    class="fz14 main_theme_color_666"
                >
                  {{ $t("cases.createImage.xe") }}
                </span>
                <el-upload
                    ref="sharpDownJaw"
                    :action="UPLOAD_URL"
                    :before-upload="
                    file =>
                      beforeFileUpload(
                        file,
                        'sharp_downjaw',
                        'stl',
                        'local_upload'
                      )
                  "
                    :data="{ token: uploadToken }"
                    :disabled="modeNoProblem"
                    :show-file-list="false"
                    class="upload-file"
                    drag
                >
                  <img
                      alt=""
                      class="dib ml40"
                      src="../../../common/imgs/case/create_img_upload_icon.png"
                      style="width: 24px; position: relative; top: 6px"
                  />
                  <span
                      :class="{
                      not_allowed: modeNoProblem,
                      disabled_btn: modeNoProblem
                    }"
                      class="up_load main_theme_color_999 fz14"
                  >{{ $t("cases.createImage.scstl") }}</span
                  >
                </el-upload>
                <p v-show="fileNameObj['sharp_downjaw']" class="up_file">
                  {{ fileNameObj["sharp_downjaw"] }}
                  <span class="up_status el-icon-success"></span>
                </p>
              </div>
            </div>
            <div v-show="diagnosisParams.digitalModelFile === 'iTero'">
              <div class="s_c__up">
                <p class="main_theme_color_666 fz14">
                  {{ $t("cases.createImage.wj") }}
                </p>
                <el-upload
                    ref="iTero"
                    :action="UPLOAD_URL"
                    :before-upload="
                    file => beforeFileUpload(file, 'iTero', 'zip', 'iTero')
                  "
                    :data="{ token: uploadToken }"
                    :disabled="modeNoProblem"
                    :show-file-list="false"
                    class="upload-file"
                    drag
                >
                  <img
                      alt=""
                      class="dib ml40"
                      src="../../../common/imgs/case/create_img_upload_icon.png"
                      style="width: 24px; position: relative; top: 6px"
                  />
                  <span
                      :class="{
                      not_allowed: modeNoProblem,
                      disabled_btn: modeNoProblem
                    }"
                      class="up_load main_theme_color_999 fz14"
                  >{{ $t("cases.createImage.sczip") }}</span
                  >
                </el-upload>
                <p v-show="fileNameObj['iTero']" class="up_file">
                  {{ fileNameObj["iTero"] }}
                  <span class="up_status el-icon-success"></span>
                </p>
              </div>
            </div>
            <div v-show="diagnosisParams.digitalModelFile === 'more_sources'"
                 :class="{
                      disable_more: modeNoProblem,
                      disabled_btn: modeNoProblem
                    }"
            >
              <div class="s_c__up more_sources  ">
                <div
                    v-for="v in MORE_LIST"
                    :key="v.value"
                    :class="moreSources === v.value ? 'file_item_active' : ''"
                    class="file_item "
                    @click="moreSources = v.value"
                >
                  {{ v.label }}
                </div>
              </div>
              <span class="more-tip-text"
              >{{ $t("注：若已通过以上软件端发送数据，请选中对应选项按钮") }}</span
              >
              <div v-if="moreSources" class="more-tip">
                1. {{ $t("登录您的") }} {{ moreDict[moreSources] }} {{ $t("用户") }};<br/>
                <br/>
                2. {{
                  $t("添加隐力公司账户“杭州隐力科技有限公司”或“service@aismile.cn”为合作伙伴，将口扫数据发送到该账户；")
                }}<br/><br/>
                3. {{ $t("如您将数据成功上传后，隐力公司审核无误后，会下载相应数据，并对数据进行数字化处理；") }}；
              </div>
            </div>
            <div v-show="diagnosisParams.digitalModelFile === 'other'">
              <div class="s_c__up">
                <p class="main_theme_color_666 fz14">
                  {{ $t("cases.createImage.wj") }}
                </p>
                <el-upload
                    ref="otherFile"
                    :action="UPLOAD_URL"
                    :before-upload="
                    file => beforeFileUpload(file, 'other_file', 'zip', 'other')
                  "
                    :data="{ token: uploadToken }"
                    :disabled="modeNoProblem"
                    :file-list="fileNameObj['other_file']"
                    :limit="10"
                    :on-exceed="otherListInit"
                    :show-file-list="false"
                    class="upload-file"
                    drag
                    multiple
                >
                  <img
                      alt=""
                      class="dib ml40"
                      src="../../../common/imgs/case/create_img_upload_icon.png"
                      style="width: 24px; position: relative; top: 6px"
                  />
                  <span
                      :class="{
                      not_allowed: modeNoProblem,
                      disabled_btn: modeNoProblem
                    }"
                      class="up_load main_theme_color_999 fz14"
                  >{{ $t("cases.createImage.sczip") }}</span
                  >
                </el-upload>
                <ul v-if="fileNameObj['other_file'].length">
                  <li
                      v-for="(item, index) in fileNameObj['other_file']"
                      :key="index"
                      :class="{ not_allowed: modeNoProblem }"
                      class="up_file other_file"
                  >
                    {{ item.realFileName }}
                    <span
                        :class="{ not_allowed: modeNoProblem }"
                        class="up_status el-icon-success"
                    ></span>
                    <span
                        :class="{ not_allowed: modeNoProblem }"
                        class="up_status el-icon-close curp"
                        @click="deleteOtherFile(index, item.id)"
                    ></span>
                  </li>
                </ul>
              </div>
            </div>
            <div
                v-if="historyFileList.length"
                class="history_submit_btn"
                @click="lookHistoryFile"
            >
              {{ $t("cases.createImage.lstj") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :id="disposeId('面像及口内照片')" class="image_single">
      <div class="image_single_header">
        <span class="vertical_line"></span>
        <p class="fz18 main_theme_color_333 mr10">
          {{ $t("cases.createImage.kqnzp") }}
        </p>
        <img
            alt=""
            class="dib mr4"
            src="../../../common/imgs/case/creater_img_ask.png"
            style="width: 12px"
        />
        <router-link
            :to="{ name: 'helpCenter', query: { type: '12' } }"
            style="display: flex; align-items: center"
            target="_blank"
        >
          <span class="main_theme_color fz14 curp">{{
              $t("cases.createImage.zppsbz")
            }}</span>
        </router-link>
      </div>
      <div class="single_con">
        <p v-if="diagnosisProblem['面像及口内照片']" class="problem_note">
          {{ diagnosisProblem['面像及口内照片'] }}
        </p>
        <ul class="up_ul">
          <li class="up_li">
            <div class="up_load">
              <div
                  v-show="diagnosisParams.sideFacePicture['nanoId']"
                  class="up_load_img"
                  @click="
                  showCarousel({
                    filed: 'sideFacePicture',
                    text:
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.cmx')
                        : $t('cases.createImage.zcmwxx'),
                    index: getPicIndex('sideFacePicture')
                  })
                "
                  @dragover.prevent
                  @drop.prevent="
                  event => {
                    handleDrop(
                      event,
                      'sideFacePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.cmx')
                        : $t('cases.createImage.zcmwxx')
                    );
                  }
                "
              >
                <img
                    v-if="diagnosisParams.sideFacePicture['nanoId']"
                    :src="
                    `${$PicPrefix}${diagnosisParams.sideFacePicture['nanoId']}?imageView2/0/w/360/h/250`
                  "
                    :style="{
                    transform: `rotate(${
                      diagnosisParams.sideFacePicture['degree']
                    }deg) scaleY(${
                      diagnosisParams.sideFacePicture['vertical'] ? -1 : 1
                    }) scaleX(${
                      diagnosisParams.sideFacePicture['horizontal'] ? -1 : 1
                    })`
                  }"
                    alt=""
                />
                <p class="pic_look">
                  <img alt="" src="/static/images/createCases/check_icon.png"/>
                  <span>{{ $t("cases.createImage.ck") }}</span>
                </p>
              </div>
              <el-upload
                  v-show="!diagnosisParams.sideFacePicture['nanoId']"
                  :action="UPLOAD_URL"
                  :before-upload="beforeUpload"
                  :data="{ token: uploadToken, key: nanoid }"
                  :on-error="uploadError"
                  :on-success="
                  res =>
                    uploadSuccess(
                      res,
                      'sideFacePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.cmx')
                        : $t('cases.createImage.zcmwxx')
                    )
                "
                  :show-file-list="false"
                  accept="image/jpeg,image/bmp,image/png"
                  class="upload-demo"
                  drag
                  list-type="picture"
              >
                <div class="up_box">
                  <p class="up_box_tip">
                    <span class="up___tip_icon"></span
                    >{{ $t("cases.createImage.sctz") }}
                  </p>
                </div>
                <p
                    v-show="!diagnosisParams.sideFacePicture['nanoId']"
                    :style="
                    `${
                      $route.query.productType === 'F'
                        ? 'transform: rotateY(180deg)'
                        : ''
                    }`
                  "
                    class="up_load_def up_load_def1"
                ></p>
              </el-upload>
              <span
                  v-show="diagnosisParams.sideFacePicture['nanoId']"
                  class="remove_pic"
                  @click="() => removeFiledPic('sideFacePicture')"
              ></span>
            </div>
            <p class="up_txt">
              <span
                  v-if="$route.query.productType !== 'D'"
                  class="main_theme_color_red mr4"
              >●</span
              >{{
                $route.query.productType !== "F"
                    ? $t("cases.createImage.cmx")
                    : $t("cases.createImage.zcmwxx")
              }}
            </p>
          </li>
          <li class="up_li">
            <div class="up_load">
              <div
                  v-show="diagnosisParams.frontFacePicture['nanoId']"
                  class="up_load_img"
                  @click="
                  showCarousel({
                    filed: 'frontFacePicture',
                    text:
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.zmx')
                        : $t('cases.createImage.zmwxx'),
                    index: getPicIndex('frontFacePicture')
                  })
                "
                  @dragover.prevent
                  @drop.prevent="
                  event => {
                    handleDrop(
                      event,
                      'frontFacePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.zmx')
                        : $t('cases.createImage.zmwxx')
                    );
                  }
                "
              >
                <img
                    v-if="diagnosisParams.frontFacePicture['nanoId']"
                    :src="
                    `${$PicPrefix}${diagnosisParams.frontFacePicture['nanoId']}?imageView2/0/w/360/h/250`
                  "
                    :style="{
                    transform: `rotate(${
                      diagnosisParams.frontFacePicture['degree']
                    }deg) scaleY(${
                      diagnosisParams.frontFacePicture['vertical'] ? -1 : 1
                    }) scaleX(${
                      diagnosisParams.frontFacePicture['horizontal'] ? -1 : 1
                    })`
                  }"
                    alt=""
                />
                <p class="pic_look">
                  <img alt="" src="/static/images/createCases/check_icon.png"/>
                  <span>{{ $t("cases.createImage.ck") }}</span>
                </p>
              </div>
              <el-upload
                  v-show="!diagnosisParams.frontFacePicture['nanoId']"
                  :action="UPLOAD_URL"
                  :before-upload="beforeUpload"
                  :data="{ token: uploadToken, key: nanoid }"
                  :on-error="uploadError"
                  :on-success="
                  res =>
                    uploadSuccess(
                      res,
                      'frontFacePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.zmx')
                        : $t('cases.createImage.zmwxx')
                    )
                "
                  :show-file-list="false"
                  accept="image/jpeg,image/bmp,image/png"
                  class="upload-demo"
                  drag
                  list-type="picture"
              >
                <div class="up_box">
                  <p class="up_box_tip">
                    <span class="up___tip_icon"></span
                    >{{ $t("cases.createImage.sctz") }}
                  </p>
                </div>
                <p
                    v-show="!diagnosisParams.frontFacePicture['nanoId']"
                    class="up_load_def up_load_def2"
                ></p>
              </el-upload>
              <span
                  v-show="diagnosisParams.frontFacePicture['nanoId']"
                  class="remove_pic"
                  @click="() => removeFiledPic('frontFacePicture')"
              ></span>
            </div>
            <p class="up_txt">
              <span
                  v-if="$route.query.productType !== 'D'"
                  class="main_theme_color_red mr4"
              >●</span
              >{{
                $route.query.productType !== "F"
                    ? $t("cases.createImage.zmx")
                    : $t("cases.createImage.zmwxx")
              }}
            </p>
          </li>
          <li class="up_li">
            <div class="up_load">
              <div
                  v-show="diagnosisParams.smilePicture['nanoId']"
                  class="up_load_img"
                  @click="
                  showCarousel({
                    filed: 'smilePicture',
                    text:
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.wxx')
                        : $t('cases.createImage.ycmwxx'),
                    index: getPicIndex('smilePicture')
                  })
                "
                  @dragover.prevent
                  @drop.prevent="
                  event => {
                    handleDrop(
                      event,
                      'smilePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.wxx')
                        : $t('cases.createImage.ycmwxx')
                    );
                  }
                "
              >
                <img
                    v-if="diagnosisParams.smilePicture['nanoId']"
                    :src="
                    `${$PicPrefix}${diagnosisParams.smilePicture['nanoId']}?imageView2/0/w/360/h/250`
                  "
                    :style="{
                    transform: `rotate(${
                      diagnosisParams.smilePicture['degree']
                    }deg) scaleY(${
                      diagnosisParams.smilePicture['vertical'] ? -1 : 1
                    }) scaleX(${
                      diagnosisParams.smilePicture['horizontal'] ? -1 : 1
                    })`
                  }"
                    alt=""
                />
                <p class="pic_look">
                  <img alt="" src="/static/images/createCases/check_icon.png"/>
                  <span>{{ $t("cases.createImage.ck") }}</span>
                </p>
              </div>
              <el-upload
                  v-show="!diagnosisParams.smilePicture['nanoId']"
                  :action="UPLOAD_URL"
                  :before-upload="beforeUpload"
                  :data="{ token: uploadToken, key: nanoid }"
                  :on-error="uploadError"
                  :on-success="
                  res =>
                    uploadSuccess(
                      res,
                      'smilePicture',
                      $route.query.productType !== 'F'
                        ? $t('cases.createImage.wxx')
                        : $t('cases.createImage.ycmwxx')
                    )
                "
                  :show-file-list="false"
                  accept="image/jpeg,image/bmp,image/png"
                  class="upload-demo"
                  drag
                  list-type="picture"
              >
                <div class="up_box">
                  <p class="up_box_tip">
                    <span class="up___tip_icon"></span
                    >{{ $t("cases.createImage.sctz") }}
                  </p>
                </div>
                <p
                    v-show="!diagnosisParams.smilePicture['nanoId']"
                    :class="
                    `up_load_def ${
                      $route.query.productType === 'F'
                        ? 'up_load_def1'
                        : 'up_load_def3'
                    }`
                  "
                ></p>
              </el-upload>
              <span
                  v-show="diagnosisParams.smilePicture['nanoId']"
                  class="remove_pic"
                  @click="() => removeFiledPic('smilePicture')"
              ></span>
            </div>
            <p class="up_txt">
              <span
                  v-if="$route.query.productType !== 'D'"
                  class="main_theme_color_red mr4"
              >●</span
              >{{
                $route.query.productType !== "F"
                    ? $t("cases.createImage.wxx")
                    : $t("cases.createImage.ycmwxx")
              }}
            </p>
          </li>
          <template v-if="$route.query.productType !== 'F'">
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.upToothPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'upToothPicture',
                      text: $t('cases.createImage.sylx'),
                      index: getPicIndex('upToothPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'upToothPicture',
                        $t('cases.createImage.sylx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.upToothPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.upToothPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.upToothPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.upToothPicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.upToothPicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.upToothPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'upToothPicture',
                        $t('cases.createImage.sylx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.upToothPicture['nanoId']"
                      class="up_load_def up_load_def4"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.upToothPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('upToothPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.sylx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.anteriorOverjetPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'anteriorOverjetPicture',
                      text: $t('cases.createImage.qyfgx'),
                      index: getPicIndex('anteriorOverjetPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'anteriorOverjetPicture',
                        $t('cases.createImage.qyfgx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.anteriorOverjetPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.anteriorOverjetPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.anteriorOverjetPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.anteriorOverjetPicture['vertical']
                          ? -1
                          : 1
                      }) scaleX(${
                        diagnosisParams.anteriorOverjetPicture['horizontal']
                          ? -1
                          : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.anteriorOverjetPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'anteriorOverjetPicture',
                        $t('cases.createImage.qyfgx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.anteriorOverjetPicture['nanoId']"
                      class="up_load_def up_load_def10"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.anteriorOverjetPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('anteriorOverjetPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.qyfgx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.downToothPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'downToothPicture',
                      text: $t('cases.createImage.xylx'),
                      index: getPicIndex('downToothPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'downToothPicture',
                        $t('cases.createImage.xylx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.downToothPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.downToothPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.downToothPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.downToothPicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.downToothPicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.downToothPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'downToothPicture',
                        $t('cases.createImage.xylx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.downToothPicture['nanoId']"
                      class="up_load_def up_load_def5"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.downToothPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('downToothPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.xylx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.mouthRightPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'mouthRightPicture',
                      text: $t('cases.createImage.knzcyx'),
                      index: getPicIndex('mouthRightPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'mouthRightPicture',
                        $t('cases.createImage.knzcyx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.mouthRightPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.mouthRightPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.mouthRightPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.mouthRightPicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.mouthRightPicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.mouthRightPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'mouthRightPicture',
                        $t('cases.createImage.knzcyx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.mouthRightPicture['nanoId']"
                      class="up_load_def up_load_def6"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.mouthRightPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('mouthRightPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.knzcyx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.mouthFrontPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'mouthFrontPicture',
                      text: $t('cases.createImage.knzwx'),
                      index: getPicIndex('mouthFrontPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'mouthFrontPicture',
                        $t('cases.createImage.knzwx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.mouthFrontPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.mouthFrontPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.mouthFrontPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.mouthFrontPicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.mouthFrontPicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.mouthFrontPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'mouthFrontPicture',
                        $t('cases.createImage.knzwx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.mouthFrontPicture['nanoId']"
                      class="up_load_def up_load_def7"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.mouthFrontPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('mouthFrontPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span class="main_theme_color_red mr4">●</span
                >{{ $t("cases.createImage.knzwx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.mouthLeftPicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'mouthLeftPicture',
                      text: $t('cases.createImage.knycyx'),
                      index: getPicIndex('mouthLeftPicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'mouthLeftPicture',
                        $t('cases.createImage.knycyx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.mouthLeftPicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.mouthLeftPicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.mouthLeftPicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.mouthLeftPicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.mouthLeftPicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.mouthLeftPicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'mouthLeftPicture',
                        $t('cases.createImage.knycyx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.mouthLeftPicture['nanoId']"
                      class="up_load_def up_load_def8"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.mouthLeftPicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('mouthLeftPicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >
                {{ $t("cases.createImage.knycyx") }}
              </p>
            </li>
          </template>
          <template v-else>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.bitePicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'bitePicture',
                      text: $t('cases.createImage.yhx'),
                      index: getPicIndex('bitePicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'bitePicture',
                        $t('cases.createImage.yhx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.bitePicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.bitePicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.bitePicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.bitePicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.bitePicture['horizontal'] ? -1 : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.bitePicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'bitePicture',
                        $t('cases.createImage.yhx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.bitePicture['nanoId']"
                      class="up_load_def up_load_def11"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.bitePicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('bitePicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.yhx") }}
              </p>
            </li>
            <li class="up_li">
              <div class="up_load">
                <div
                    v-show="diagnosisParams.openAndClosePicture['nanoId']"
                    class="up_load_img"
                    @click="
                    showCarousel({
                      filed: 'openAndClosePicture',
                      text: $t('cases.createImage.khx'),
                      index: getPicIndex('openAndClosePicture')
                    })
                  "
                    @dragover.prevent
                    @drop.prevent="
                    event => {
                      handleDrop(
                        event,
                        'openAndClosePicture',
                        $t('cases.createImage.khx')
                      );
                    }
                  "
                >
                  <img
                      v-if="diagnosisParams.openAndClosePicture['nanoId']"
                      :src="
                      `${$PicPrefix}${diagnosisParams.openAndClosePicture['nanoId']}?imageView2/0/w/360/h/250`
                    "
                      :style="{
                      transform: `rotate(${
                        diagnosisParams.openAndClosePicture['degree']
                      }deg) scaleY(${
                        diagnosisParams.openAndClosePicture['vertical'] ? -1 : 1
                      }) scaleX(${
                        diagnosisParams.openAndClosePicture['horizontal']
                          ? -1
                          : 1
                      })`
                    }"
                      alt=""
                  />
                  <p class="pic_look">
                    <img
                        alt=""
                        src="/static/images/createCases/check_icon.png"
                    />
                    <span>{{ $t("cases.createImage.ck") }}</span>
                  </p>
                </div>
                <el-upload
                    v-show="!diagnosisParams.openAndClosePicture['nanoId']"
                    :action="UPLOAD_URL"
                    :before-upload="beforeUpload"
                    :data="{ token: uploadToken, key: nanoid }"
                    :on-error="uploadError"
                    :on-success="
                    res =>
                      uploadSuccess(
                        res,
                        'openAndClosePicture',
                        $t('cases.createImage.khx')
                      )
                  "
                    :show-file-list="false"
                    accept="image/jpeg,image/bmp,image/png"
                    class="upload-demo"
                    drag
                    list-type="picture"
                >
                  <div class="up_box">
                    <p class="up_box_tip">
                      <span class="up___tip_icon"></span
                      >{{ $t("cases.createImage.sctz") }}
                    </p>
                  </div>
                  <p
                      v-show="!diagnosisParams.openAndClosePicture['nanoId']"
                      class="up_load_def up_load_def12"
                  ></p>
                </el-upload>
                <span
                    v-show="diagnosisParams.openAndClosePicture['nanoId']"
                    class="remove_pic"
                    @click="() => removeFiledPic('openAndClosePicture')"
                ></span>
              </div>
              <p class="up_txt">
                <span
                    v-if="$route.query.productType !== 'D'"
                    class="main_theme_color_red mr4"
                >●</span
                >{{ $t("cases.createImage.khx") }}
              </p>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div
        v-if="
        ['A', 'B', 'C', 'E', 'G', 'H', 'I'].includes($route.query.productType)
      "
        :id="disposeId('X光片')"
        class="image_single"
    >
      <div class="image_single_header">
        <span class="vertical_line"></span>
        <p class="fz18 main_theme_color_333 mr4">
          {{ $t("cases.createImage.xgp") }}
        </p>
        <span
            v-if="diagnosisParams['downjawFar'] || diagnosisParams['upjawFar']"
            class="main_theme_color_red mr10 fz14"
        >●</span
        >
        <img
            alt=""
            class="dib mr4"
            src="../../../common/imgs/case/creater_img_ask.png"
            style="width: 12px"
        />
        <router-link
            :to="{ name: 'helpCenter', query: { type: '13' } }"
            style="display: flex; align-items: center"
            target="_blank"
        >
          <span class="fz14 main_theme_color">{{
              $t("cases.createImage.xgpbz")
            }}</span>
        </router-link>
      </div>
      <div class="single_con">
        <p v-if="diagnosisProblem['X光片']" class="problem_note">
          {{ diagnosisProblem['X光片'] }}
        </p>
        <ul class="up_ul" style="justify-content: left">
          <li class="up_li" style="margin-right: 0.96rem">
            <div class="up_load">
              <div
                  v-show="diagnosisParams.xrayCurvePicture['nanoId']"
                  class="up_load_img"
                  @click="
                  showCarousel({
                    filed: 'xrayCurvePicture',
                    text: $t('cases.createImage.dcp'),
                    index: getPicIndex('xrayCurvePicture')
                  })
                "
                  @dragover.prevent
                  @drop.prevent="
                  event => {
                    handleDrop(
                      event,
                      'xrayCurvePicture',
                      $t('cases.createImage.dcp')
                    );
                  }
                "
              >
                <img
                    v-if="diagnosisParams.xrayCurvePicture['nanoId']"
                    :src="
                    `${$PicPrefix}${diagnosisParams.xrayCurvePicture['nanoId']}?imageView2/0/w/360/h/250`
                  "
                    :style="{
                    transform: `rotate(${
                      diagnosisParams.xrayCurvePicture['degree']
                    }deg) scaleY(${
                      diagnosisParams.xrayCurvePicture['vertical'] ? -1 : 1
                    }) scaleX(${
                      diagnosisParams.xrayCurvePicture['horizontal'] ? -1 : 1
                    })`
                  }"
                    alt=""
                />
                <p class="pic_look">
                  <img alt="" src="/static/images/createCases/check_icon.png"/>
                  <span>{{ $t("cases.createImage.ck") }}</span>
                </p>
              </div>
              <el-upload
                  v-show="!diagnosisParams.xrayCurvePicture['nanoId']"
                  :action="UPLOAD_URL"
                  :before-upload="beforeUpload"
                  :data="{ token: uploadToken, key: nanoid }"
                  :on-error="uploadError"
                  :on-success="
                  res =>
                    uploadSuccess(
                      res,
                      'xrayCurvePicture',
                      $t('cases.createImage.dcp')
                    )
                "
                  :show-file-list="false"
                  accept="image/jpeg,image/bmp,image/png"
                  class="upload-demo"
                  drag
                  list-type="picture"
              >
                <div class="up_box">
                  <p class="up_box_tip">
                    <span class="up___tip_icon"></span
                    >{{ $t("cases.createImage.sctz") }}
                  </p>
                </div>
                <p
                    v-show="!diagnosisParams.xrayCurvePicture['nanoId']"
                    class="up_load_def up_load_def9"
                ></p>
              </el-upload>
              <span
                  v-show="diagnosisParams.xrayCurvePicture['nanoId']"
                  class="remove_pic"
                  @click="() => removeFiledPic('xrayCurvePicture')"
              ></span>
            </div>
            <p class="up_txt">{{ $t("cases.createImage.dcp") }}</p>
          </li>
          <li class="up_li">
            <div class="up_load">
              <div
                  v-show="diagnosisParams.xraySidePicture['nanoId']"
                  class="up_load_img"
                  @click="
                  showCarousel({
                    filed: 'xraySidePicture',
                    text: $t('cases.createImage.dwp'),
                    index: getPicIndex('xraySidePicture')
                  })
                "
                  @dragover.prevent
                  @drop.prevent="
                  event => {
                    handleDrop(
                      event,
                      'xraySidePicture',
                      $t('cases.createImage.dwp')
                    );
                  }
                "
              >
                <div class="up_load_img_pic"></div>
                <img
                    v-if="diagnosisParams.xraySidePicture['nanoId']"
                    :src="
                    `${$PicPrefix}${diagnosisParams.xraySidePicture['nanoId']}?imageView2/0/w/360/h/250`
                  "
                    :style="{
                    transform: `rotate(${
                      diagnosisParams.xraySidePicture['degree']
                    }deg) scaleY(${
                      diagnosisParams.xraySidePicture['vertical'] ? -1 : 1
                    }) scaleX(${
                      diagnosisParams.xraySidePicture['horizontal'] ? -1 : 1
                    })`
                  }"
                    alt=""
                />
                <p class="pic_look">
                  <img alt="" src="/static/images/createCases/check_icon.png"/>
                  <span>{{ $t("cases.createImage.ck") }}</span>
                </p>
              </div>
              <el-upload
                  v-show="!diagnosisParams.xraySidePicture['nanoId']"
                  :action="UPLOAD_URL"
                  :before-upload="beforeUpload"
                  :data="{ token: uploadToken, key: nanoid }"
                  :on-error="uploadError"
                  :on-success="
                  res =>
                    uploadSuccess(
                      res,
                      'xraySidePicture',
                      $t('cases.createImage.dwp')
                    )
                "
                  :show-file-list="false"
                  accept="image/jpeg,image/bmp,image/png"
                  class="upload-demo"
                  drag
                  list-type="picture"
              >
                <div class="up_box">
                  <p class="up_box_tip">
                    <span class="up___tip_icon"></span
                    >{{ $t("cases.createImage.sctz") }}
                  </p>
                </div>
                <p
                    v-show="!diagnosisParams.xraySidePicture['nanoId']"
                    class="up_load_def up_load_def9"
                ></p>
              </el-upload>
              <span
                  v-show="diagnosisParams.xraySidePicture['nanoId']"
                  class="remove_pic"
                  @click="() => removeFiledPic('xraySidePicture')"
              ></span>
            </div>
            <p class="up_txt">{{ $t("cases.createImage.dwp") }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div
        v-if="!isAestheticBraces"
        :id="disposeId('其他影像资料')"
        class="image_single"
    >
      <div class="image_single_header">
        <span class="vertical_line"></span>
        <p class="fz18 main_theme_color_333 mr10">
          {{ $t("cases.createImage.yxzl") }}
        </p>
      </div>
      <div class="single_con">
        <p
            v-if="diagnosisProblem['其他影像资料']"
            class="problem_note ml30"
        >
          {{ diagnosisProblem['其他影像资料'] }}
        </p>
        <p class="ml30">
          <span class="fz14 main_theme_color_333">{{
              $t("cases.createImage.ktztp")
            }}</span>
          <span class="c-red fz14">
            {{ $t("cases.createImage.zdten") }}
          </span>
        </p>
        <div class="other_img ml30">
          <div
              v-for="(other, uxd) in fileList"
              v-show="fileList.length"
              :key="uxd"
              class="img_item"
              @mouseenter="OtherImgMouseenter(uxd)"
              @mouseleave="isShowOtherItem = ''"
              @dragover.prevent
              @drop.prevent="
              event => {
                handleDrop(
                  event,
                  'otherPicture',
                  $t('cases.createImage.yxzl'),
                  uxd
                );
              }
            "
              @click.prevent.stop="
              showCarousel({
                filed: 'otherPicture',
                index: other.index,
                text: other.text
              })
            "
          >
            <img
                :src="`${$PicPrefix}${other['nanoId']}?imageView2/0/w/360/h/250`"
                :style="{
                transform: `rotate(${other['degree']}deg) scaleY(${
                  other['vertical'] ? -1 : 1
                }) scaleX(${other['horizontal'] ? -1 : 1})`
              }"
                alt=""
                class="img-content"
            />
            <div v-if="isShowOtherItem === uxd" class="icon">
              <i class="el-icon-view icon_font curp"></i>
              <span class="c-white">{{ $t("cases.createImage.ck") }}</span>
            </div>
            <div
                class="delete_icon"
                @click.self.prevent.stop="deleteOtherImg(uxd, other.index)"
            ></div>
          </div>
          <template v-if="fileList.length < 10">
            <el-upload
                ref="otherUpload"
                :action="UPLOAD_URL"
                :before-upload="beforeUpload"
                :data="{ token: uploadToken, key: nanoid }"
                :file-list="other_list"
                :limit="10"
                :on-error="uploadError"
                :on-exceed="pictureExceedHintMassage"
                :on-remove="picture => handleRemove(picture)"
                :on-success="
                (res, file) =>
                  uploadSuccess(
                    res,
                    'otherPicture',
                    $t('cases.createImage.yxzl'),
                    file,
                    'other'
                  )
              "
                :show-file-list="false"
                accept="image/jpeg,image/bmp,image/png"
                class="upload-demo"
                drag
                list-type="picture"
            >
              <div class="up_box">
                <p class="up_box_tip">
                  <span class="up___tip_icon"></span
                  >{{ $t("cases.createImage.sctz") }}
                </p>
              </div>
              <p class="other_bc_img up_load_def9"></p>
            </el-upload>
          </template>
        </div>
      </div>
    </div>
    <div
        v-if="!isAestheticBraces"
        :id="disposeId('CBCT')"
        class="image_single mt30"
    >
      <div class="image_single_header">
        <span class="vertical_line"></span>
        <p class="fz18 main_theme_color_333 mr10">
          CBCT
        </p>
      </div>
      <div class="single_con">
        <p
            v-if="diagnosisProblem['CBCT']"
            class="problem_note ml30"
        >
          {{ diagnosisProblem['CBCT'] }}
        </p>
        <div class="s_c_box">

          <div class="s_c__right">
            <div class="s_c__up">
              <el-upload
                  ref="CBCT"
                  :action="UPLOAD_URL"
                  :before-upload="file => beforeUploadCbct(file, 'cbct', 'zip')"
                  :data="{ token: uploadToken }"
                  :on-exceed="otherListInit"
                  :on-progress="(event)=>uploadCbctProgress(event,)"
                  :show-file-list="false"
                  class="upload-cbct"
                  drag
              >
                <i class="el-icon-upload"/>
                <div class="upload-text">{{ $t("将文件拖到此处，或 点击上传") }}</div>
                <div class="el-upload__tip">
                  {{ $t("压缩包内文件") }}:<i class="el-icon-success icon_success"/>dcm
                  <i class="el-icon-error icon_error"/> .arch .exe .png .stl
                </div>
                <div class="el-upload__tip">
                  {{ $t("只能上传上传rar、zip或7z格式的压缩包,压缩包大小必须小于1500M") }}
                </div>
                <div v-if="uploadProgress" slot="tip" class="progress-wrap">
                  <el-progress :percentage="uploadProgress"></el-progress>
                </div>

                <div v-show="fileNameObj['cbct']" slot="tip" class="upload_text">
                  {{ fileNameObj["cbct"] }}
                  <div>
                    <span class="icon_success el-icon-circle-check"></span>
                    <span class="el-icon-close"
                          @click="deleteOtherFile(0, fileNameObj,'cbct')"></span>
                  </div>
                </div>
              </el-upload>

            </div>
          </div>
        </div>
      </div>
    </div>

    <FullLoading v-show="isLoading"/>

    <LookPic
        ref="LookPic"
        :canChange="true"
        :carouselList="carouselList"
        :curePlanId="$route.query.curePlanId"
        :picKey="'index'"
        :uploadToken="uploadToken"
        @changeCarouselList="changeCarouselList"
    />

    <el-dialog
        :show-close="false"
        :title="$t('cases.createImage.lstj')"
        :visible.sync="historyFileVisible"
        class="status_modal"
    >
      <div slot="title" class="modal_header">
        <div class="title">
          {{ $t('cases.createImage.lstj') }}
        </div>
        <div class="el-icon-close" @click="historyFileVisible = false"/>
      </div>
      <div style="height: 4rem">
        <el-scrollbar style="height: 100%">
          <el-table :data="historyFileList">
            <el-table-column
                :label="$t('home.home.sj')"
                prop="createDatetime"
                width="220"
            ></el-table-column>
            <el-table-column
                :label="$t('casesDetail.casesDetail.jd')"
                prop="node"
                width="150"
            >
              <template slot-scope="scope">
                <div>
                  {{ stageDictObj[scope.row.stage] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('casesDetail.casesDetail.wjm')"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    map(
                        scope.row.attachmentHisList,
                        item => item.realFileName
                    ).join(",")
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('common.common.xz')"
                width="100"
            >
              <template slot-scope="scope">
                <div class="download_btn" @click="downFile(scope.row)">
                  {{ $t("common.common.xz") }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="cancel_btn" @click="historyFileVisible = false">
          {{ $t("casesDetail.casesChildren.common.qx") }}
        </div>
        <div class="sure_btn" @click="historyFileVisible = false">
          {{ $t("casesDetail.casesChildren.common.qd") }}
        </div>
      </span>
    </el-dialog>
    <ExBirdie
        ref="exBirdie"
        :caseDetail="caseDetail"
        :defaultKey="exDefaultKey"
        refType="1"
        @tabsChange="tabsChanged"
    />

    <PreviewImg
        ref="previewImg"
        :carouselList="carouselList"
        @imgChange="imgChange"
    />
  </div>
</template>

<script>
import $ from "jquery";
import * as QINIU from "qiniu-js";
import clipboard from "clipboard";
import {UPLOAD_URL} from "common/js/config";
import {getQiniuToken, getDictAllList} from "common/api/public";
import {
  notifyMsg,
  downImage,
  toHtml2canvas,
  dataURLtoBlob,
  putb64,
  downloadFileList, beforeSubmit
} from "common/js/util";
import FullLoading from "components/full-loading/full-loading";
import TheDelivery from "./the-delivery";
import {
  createCurePlan,
  editCurePlan,
  detailCurePlan,
  PublicAttachmentLogList,
  createLogistics,
  cureProblemList
} from "common/api/cases";
import {getDictList} from "common/api/public";
import {mapState, mapActions, mapGetters} from "vuex";
import {
  map,
  filter,
  isArray,
  extend,
  each,
  some,
  get,
  find,
  pickBy
} from "lodash";
import {changeRouteQuery} from "../../../common/js/Fn";
import CDate from "common/js/CDate";
import ExBirdie from "../../../components/expressage_birdie/index";
import LookPic from "components/lookPic-copy/index";
import PreviewImg from "components/preview-image/preview-image.vue";
import {nanoid} from "nanoid";
import {A_Dict as problemDict} from "common/js/problemDict";

export default {
  data() {
    return {
      uploadProgress: 0,
      moreDict: {},
      MORE_LIST: [],
      moreSources: "",
      copyCases: null,
      isLoading: false,
      isSendExpress: false,
      dialogVisible: false,
      isShowOtherItem: "",
      other_list: [],
      UPLOAD_URL,
      uploadToken: "",
      dictObj: {},
      diagnosisProblem: {},
      problemList: [],
      caseNumber: "",
      diagnosisParams: {
        siliconeRubberModel: "",
        digitalModelFile: "",
        attachmentInfoList: [],
        sideFacePicture: "", // 侧面像
        frontFacePicture: "", // 正面像
        smilePicture: "", // 微笑像
        upToothPicture: "", // 上牙列像
        downToothPicture: "", // 下牙列像
        mouthRightPicture: "", // 口内右侧位像
        mouthFrontPicture: "", // 口内正位像
        mouthLeftPicture: "", // 口内左侧位像
        xrayCurvePicture: "", // 全颌曲面断层片
        xraySidePicture: "", // 头颅侧位定位片
        otherPicture: "", // 其他影像资料
        anteriorOverjetPicture: "", //前牙覆盖像
        bitePicture: "", // 咬合像
        openAndClosePicture: "" // 开合像
      },
      fileNameObj: {
        cbct: '',
        other_file: [],
        iTero: "",
        sharp_upjaw: "",
        sharp_downjaw: ""
      },
      diaKeyObj: {},
      carouselList: [],
      carouselName: "",
      carouselFiled: 0,
      picNum: 1,
      rotateNumX: 0,
      rotateNumY: 0,
      rotateNum: 0,
      fileList: [],
      isAestheticBraces: this.$route.query.productType === "D",
      isYysd: this.$route.query.productType === "F",
      isEditFileList: [],
      modeNoProblem: false,
      isResponse: 0,
      historyFileVisible: false,
      historyFileList: [],
      stageDictObj: {},
      currentImg: "",
      isRdtBack: JSON.parse(sessionStorage.getItem("needRTD")) || false,
      exDefaultKey: "",
      nanoid: nanoid(),
      idxObj: {
        sideFacePicture: 0,
        frontFacePicture: 1,
        smilePicture: 2,
        upToothPicture: 3,
        anteriorOverjetPicture: 4,
        downToothPicture: 5,
        mouthRightPicture: 6,
        mouthFrontPicture: 7,
        mouthLeftPicture: 8,
        xrayCurvePicture: 9,
        xraySidePicture: 10
      },
      yysdIdxObj: {
        sideFacePicture: 0,
        frontFacePicture: 1,
        smilePicture: 2,
        bitePicture: 3,
        openAndClosePicture: 4
      }
    };
  },
  props: {
    caseDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      language: state => state.language
    }),
    ...mapGetters({
      commonCaseCureDetail: "getCommonCaseCureDetail" //治疗表详情
    }),
    queryProductType() {
      return this.$route.query.productType;
    },
    queryCaseId() {
      return this.$route.query.caseId;
    },
    queryCurePlanId() {
      return this.$route.query.curePlanId;
    }
  },
  methods: {
    ...mapActions({
      getCaseCureDetail: "actionGetCaseCureDetail" //治疗表详情
    }),
    map,
    get,
    handleDrop(event, filed, name, uxd) {
      const file = event.dataTransfer.files[0];
      this.nanoid = nanoid();
      const supportedFormats = ["image/jpeg", "image/png", "image/bmp"];
      let isLt20M = file.size / 1024 / 1024 < 20;
      if (!supportedFormats.includes(file.type)) {
        notifyMsg(this, "warning", this.$t("common.message.supportedFormats"));
        return false;
      } else if (!isLt20M) {
        notifyMsg(this, "warning", this.$t("common.message.isLt20M"));
        return false;
      } else {
        // this.isLoading = true;
        this.beforeDrop(file, filed, name, uxd);
      }
    },
    async beforeDrop(file, filed, name, uxd) {
      const params = await new Promise((resolve, reject) => {
        const formData = new FormData();
        // 在form实例中添加 file qiniuToekn 固定格式类名
        formData.append("file", file);
        formData.append("token", this.uploadToken);
        formData.append("key", nanoid());
        const fileName = file.name.replace(/\s/g, ""); // 去除空格
        const ts = new Date().getTime();
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "https://upload.qiniup.com/", true);
        // 携带登录token
        xhr.setRequestHeader("Authorization", localStorage.getItem("token"));

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            // 根据组件 api 返回固定格式的 url
            const response = JSON.parse(xhr.responseText);
            // const alt = response.key;
            resolve(response);
          } else if (xhr.readyState === 4 && xhr.status !== 200) {
            reject("上传失败"); // 如果上传失败，返回错误信息
          }
        };
        xhr.send(formData);
      });
      if (filed !== "otherPicture") {
        this.carouselList = this.carouselList.filter(v => v?.filed !== filed);
        this.uploadSuccess(params, filed, name);
      } else {
        this.uploadSuccess(params, filed, name, file, "other", uxd + 1);
      }
    },
    imgChange(obj, idx) {
      const current = this.carouselList[idx];
      if (obj.filed !== "otherPicture") {
        this.diagnosisParams[current.filed] = {
          nanoId: this.diagnosisParams[current.filed].nanoId,
          degree: obj.degree,
          horizontal: obj.horizontal,
          vertical: obj.vertical,
          ETag: obj.ETag
        };
      } else {
        this.fileList.map(item => {
          if (item.index == current.index) {
            this.$set(item, "degree", obj.degree);
            this.$set(item, "horizontal", obj.horizontal);
            this.$set(item, "vertical", obj.vertical);
          }
        });
      }
    },
    changeCarouselList({hash, Filed}) {
      this.carouselList = map(this.carouselList, item => {
        if (item.index === Filed) {
          if (item.filed === "otherPicture") {
            let otherPicListStr = map(
                filter(
                    this.carouselList,
                    other =>
                        other.filed === "otherPicture" && other["index"] !== Filed
                ),
                it => {
                  let itList = it.href.split("/");
                  return itList[itList.length - 1];
                }
            ).join(",");
            this.diagnosisParams.otherPicture = `${hash},${otherPicListStr}`;
            this.fileList = map(this.fileList, it => {
              if (it.index === Filed) {
                return extend({}, it, {href: this.$PicPrefix + hash});
              }
              return it;
            });
          } else if (item.filed in this.diagnosisParams) {
            this.diagnosisParams[item.filed] = hash;
          }
          return {
            ...item,
            href: this.$PicPrefix + hash
          };
        }
        return item;
      });
    },
    tabsChanged(key) {
      this.diagnosisParams.siliconeRubberModel = key;
    },
    showModel(key) {
      return key === "self_deliver"
          ? +get(this.caseDetail, "selfDeliverFlag") === 1
          : true;
    },

    disposeId(groupName) {
      return problemDict?.picModalDict.findIndex(item => item === groupName);
    },
    jumpLocation(groupName) {
      const number = problemDict?.picModalDict.findIndex(
          item => item === groupName
      );
      document.documentElement.scrollTop = document.getElementById(
          number
      ).offsetTop;
    },
    downFile(item) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      //   color: '#fcc80e'
      // });
      this.isLoading = true
      let name = `${this.caseNumber}_${
          this.diagnosisParams.userInfo.realName
      }_${new CDate().format("yyyy-MM-dd")}`;
      downloadFileList(item.attachmentHisList, true, name, this.$PicPrefix).then(() => {
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
      // loading.close();
    },
    getDictList() {
      getDictList("case.stage").then(data => {
        each(data, item => {
          this.stageDictObj[item.key] = item.value;
        });
      });
    },
    getHistoryFileList() {
      return PublicAttachmentLogList({
        caseId: this.$route.query.caseId,
        nodeList: ["to_submit", "to_resubmit"]
      }).then(data => {
        this.historyFileList = data;
      });
    },
    lookHistoryFile() {
      this.historyFileVisible = true;
    },
    otherListInit() {
      this.$message.warning(this.$t("cases.createImage.zdxz"));
    },
    deleteOtherFile(index, id, key = "other_file") {
      if (key === 'cbct') {
        this.diagnosisParams.attachmentInfoList = this.diagnosisParams.attachmentInfoList?.filter(item => item.fileKey !== 'cbct')
        this.diagnosisParams.attachmentList = this.diagnosisParams.attachmentInfoList

        this.fileNameObj[key] = ''
        return;
      }
      if (this.modeNoProblem) return;

      this.fileNameObj[key].splice(index, 1);
      this.diagnosisParams.attachmentInfoList = filter(
          map(this.diagnosisParams.attachmentInfoList, item => {
            if (item.id === id) {
              return;
            }
            return item;
          })
      );
      this.diagnosisParams.attachmentList = this.diagnosisParams.attachmentInfoList
    },
    repulseNumber(type) {
      return {
        model: {
          A: 20,
          B: 22,
          C: 20,
          D: 4,
          E: 21,
          F: 17,
          G: 22,
          H: 22,
          I: 8
        }[this.queryProductType],
        face: {
          A: 21,
          B: 23,
          C: 21,
          D: 5,
          E: 22,
          F: 15,
          G: 23,
          H: 23,
          I: 9
        }[this.queryProductType],
        x: {
          A: 22,
          B: 24,
          C: 22,
          D: 6,
          E: 23,
          F: 17,
          G: 24,
          H: 24,
          I: 10
        }[this.queryProductType],
        other: {
          A: 23,
          B: 25,
          C: 23,
          D: 7,
          E: 24,
          F: 16,
          G: 25,
          H: 25,
          I: 11
        }[this.queryProductType]
      }[type];
    },
    getPicIndex(filed) {
      return filter(this.carouselList, item => item.filed === filed)[0]?.index;
    },
    showCarousel(item) {
      this.$nextTick(() => {
        this.$refs["previewImg"] &&
        this.$refs["previewImg"].show(item.text, item.index);
      });
    },
    sendExpress() {
      if (this.modeNoProblem) return;
      this.exDefaultKey = "silicagel_print_model";
      this.$refs["exBirdie"].openDia().then(() => {
        this.$refs["exBirdie"] &&
        this.$refs["exBirdie"].resetClinic(this.caseDetail.clinicId);
        this.saveData();
      });
    },
    copyCasesNumber() {
      notifyMsg(this, "success", this.$t("cases.createImage.fzcg"));
    },
    selectedProblem(ev, filed) {
      if (this.modeNoProblem) return;
      const target = ev.target;
      if (target.tagName.toLocaleLowerCase() === "span") {
        const val = target.getAttribute("data-key");
        if (filed === "siliconeRubberModel") {
          this.diagnosisParams.digitalModelFile = "";
          this.fileNameObj = {
            cbct: this.fileNameObj?.cbct,
            other_file: [],
            iTero: "",
            sharp_upjaw: "",
            sharp_downjaw: ""
          };
          this.exDefaultKey = val;
          if (val === "self_deliver") {
            this.$refs["exBirdie"].openDia().then(() => {
              this.saveData();
            });
          }
        }
        if (filed === "digitalModelFile") {
          this.diagnosisParams.siliconeRubberModel = "";
        }
        if (this.diagnosisParams[filed] !== val) {
          this.remarkParams = {
            ...this.remarkParams,
            [filed]: null
          };
          this.remarkObj = {
            ...this.remarkObj,
            [filed]: null
          };
          this.diagnosisParams = {
            ...this.diagnosisParams,
            [filed]: val
          };
        } else {
          if (filed !== "siliconeRubberModel") {
            delete this.diagnosisParams[filed];
            this.diagnosisParams = {
              ...this.diagnosisParams
            };
          }
        }
        if (filed === "digitalModelFile") {
          window.scrollTo(0, 0);
        }
      }
    },
    async handleUpload(file, key, type) {
      const _this = this;
      _this.isLoading = true;
      const fileName = file.name.replace(/\s/g, ""); // 去除空格
      const ts = new Date().getTime();
      const params = await new Promise((resolve, reject) => {
        const formData = new FormData();
        // 在form实例中添加 file qiniuToekn 固定格式类名
        formData.append("file", file);
        formData.append("token", this.uploadToken);
        formData.append("key", `${ts}_${fileName}`);
        // 发起xhr请求
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "https://upload.qiniup.com/", true);
        // 携带登录token
        xhr.setRequestHeader("Authorization", localStorage.getItem("token"));
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            _this.isLoading = false;
            const response = JSON.parse(xhr.responseText);
            resolve(response); // 将图片URL传递给富文本编辑器
          } else if (xhr.readyState === 4 && xhr.status !== 200) {
            _this.isLoading = false;
            reject("上传失败"); // 如果上传失败，返回错误信息
          }
        };
        xhr.send(formData);
      });
      const {attachmentInfoList} = _this.diagnosisParams;
      const list = !["other_file"].includes(key)
          ? attachmentInfoList.filter(item => item.fileKey !== key)
          : attachmentInfoList;
      _this.diagnosisParams.attachmentInfoList = [
        ...list,
        {
          fileKey: key,
          fileName: params?.key,
          realFileName: fileName,
          fileType: type,
          fileUrl: params?.hash,
          fileSource: "DOCTOR"
        }
      ];

      _this.fileNameObj[key] = !["other_file",].includes(key)
          ? fileName
          : [..._this.fileNameObj[key], {realFileName: fileName}];
    },
    uploadCbctProgress(event,) {
      if (event) {
        if (event?.percent !== 100) {
          this.uploadProgress = parseFloat(event.percent.toFixed(0))
        } else {
          this.uploadProgress = 0
        }
      }
    },
    beforeUploadCbct(file, key, type) {
      const MAX_SIZE = 1500 * 1024 * 1024;
      let typeList = ["zip", "rar", "7z"];
      if (file.size > MAX_SIZE) {
        notifyMsg(this, "warning", `压缩包大小必须小于 1500M!`);
        return false; // 返回 false 阻止上传
      }
      const fileType = file?.name?.split(".").pop();
      if (
          type === "zip" ? typeList.includes(fileType) : name.indexOf(type) > 0
      ) {
        this.isLoading = true;
        this.handleUpload(file, key, type);
        return true
      } else {
        notifyMsg(
            this,
            "warning",
            `${this.$t("common.message.qxz")}${
                type === "zip" ? "zip或rar" : type
            }${this.$t("common.message.wjsc")}`
        );
        return false;
      }

    },
    beforeFileUpload(file, key, type, tabKey) {
      const {name} = file;
      let typeList = ["zip", "rar"];
      const fileType = name?.split(".").pop();
      if (
          type === "zip" ? typeList.includes(fileType) : name.indexOf(type) > 0
      ) {
        this.isLoading = true;
        this.handleUpload(file, key, type);
      } else {
        notifyMsg(
            this,
            "warning",
            `${this.$t("common.message.qxz")}${
                type === "zip" ? "zip或rar" : type
            }${this.$t("common.message.wjsc")}`
        );
      }
      return false;
    },
    //删除其他影像图片
    deleteOtherImg(index, carouseIndex) {
      this.carouselList.splice(carouseIndex, 1);
      this.other_list.splice(index, 1);
      this.carouselList.map((item, index) => {
        this.carouselList[index].index = index + "";
      });
      let list = [];
      this.carouselList.map(item => {
        if (item.filed === "otherPicture") {
          list.push({
            href: item.href,
            index: item.index,
            text: item.name,
            nanoId: item.nanoId,
            ETag: item.ETag,
            degree: item.degree,
            horizontal: item.horizontal,
            vertical: item.vertical
          });
        }
      });
      this.fileList = list;
    },
    OtherImgMouseenter(index) {
      this.isShowOtherItem = index;
    },
    pictureExceedHintMassage() {
      return notifyMsg(this, "warning", this.$t("cases.createImage.zdten"));
    },
    isJSON(str) {
      if (str == "") {
        return "";
      }
      if (typeof str == "string") {
        try {
          JSON.parse(str);
          let obj = JSON.parse(str);
          !obj.nanoId && (obj.nanoId = obj.ETag);
          !obj.degree && (obj.degree = 0);
          !obj.horizontal && (obj.horizontal = false);
          !obj.vertical && (obj.vertical = false);
          return obj;
        } catch (error) {
          return {
            ETag: str,
            nanoId: str,
            degree: 0,
            horizontal: false,
            vertical: false
          };
        }
      }
    },
    uploadSuccess(res, filed, name, file, type, i) {
      this.isLoading = false;
      const {diagnosisParams} = this;
      if (type !== "other") {
        diagnosisParams[filed] = {ETag: res.key, nanoId: res.key};
      }
      let index = this.carouselList.length;
      if (filed !== "otherPicture") {
        this.carouselList.splice(
            this.$route.query.productType == "F"
                ? this.yysdIdxObj[filed]
                : this.idxObj[filed],
            0,
            {
              nanoId: res.key,
              name,
              ETag: res.key,
              href: this.$PicPrefix + res.hash,
              filed
            }
        );
      } else {
        if (!i) {
          this.carouselList.push({
            nanoId: res.key,
            name,
            ETag: res.key,
            href: this.$PicPrefix + res.hash,
            filed,
            index: index + ""
          });
        } else {
          const _etag = this.fileList[i - 1]?.ETag;
          this.carouselList = this.carouselList?.map(v => {
            if (_etag === v?.ETag) {
              return {
                ...v,
                ETag: res.key,
                href: this.$PicPrefix + res.hash,
                nanoId: res.key
              };
            } else {
              return v;
            }
          });
        }
      }
      this.carouselList.map((item, index) => {
        this.carouselList[index].index = index + "";
      });
      if (type === "other") {
        if (i) {
          const _etag = this.fileList[i - 1]?.ETag;
          this.fileList = this.fileList?.map(v => {
            if (_etag === v?.ETag) {
              return {
                ...v,
                ETag: res.key,
                href: this.$PicPrefix + res.hash,
                nanoId: res.key
              };
            } else {
              return v;
            }
          });
        } else {
          this.fileList.push({
            nanoId: res.key,
            name,
            ETag: res.key,
            href: this.$PicPrefix + res.hash,
            filed,
            index: index + ""
          });
        }
      }
      notifyMsg(this, "success", this.$t("common.message.tpsccg"));
    },
    uploadError() {
      this.isLoading = false;
      return notifyMsg(this, "error", this.$t("common.message.scsb"));
    },
    handleRemove(img) {
      let url = img.response.hash;
      let index = this.fileList.indexOf(url);
      this.fileList.splice(index, 1);
    },
    beforeUpload(file) {
      this.nanoid = nanoid();
      const supportedFormats = ["image/jpeg", "image/png", "image/bmp"];
      let isLt20M = file.size / 1024 / 1024 < 20;
      if (!supportedFormats.includes(file.type)) {
        notifyMsg(this, "warning", this.$t("common.message.supportedFormats"));
        return false;
      } else if (!isLt20M) {
        notifyMsg(this, "warning", this.$t("common.message.isLt20M"));
        return false;
      } else {
        this.isLoading = true;
        return true;
      }
    },
    removeFiledPic(filed) {
      const {diagnosisParams} = this;
      this.diagnosisParams = {
        ...diagnosisParams,
        [filed]: ""
      };
      this.carouselList = this.carouselList.filter(
          item => item.filed !== filed
      );
      this.carouselList.map((item, index) => {
        this.carouselList[index].index = index + "";
      });
    },
    async saveData() {
      this.isLoading = true;
      await this.$nextTick();
      if (
          this.isEditFileList.length !==
          this.diagnosisParams.attachmentInfoList.length
      ) {
        this.diagnosisParams.attachmentInfoList = map(
            this.diagnosisParams.attachmentInfoList,
            item => {
              return extend({}, item, {fileSource: "DOCTOR"});
            }
        );
      }
      if (
          this.isEditFileList.length ===
          this.diagnosisParams.attachmentInfoList.length
      ) {
        let list = [];
        each(this.isEditFileList, old => {
          each(this.diagnosisParams.attachmentInfoList, newFile => {
            if (old.fileName === newFile.fileName) {
              list.push(true);
            }
          });
        });
        if (list.length < this.isEditFileList.length) {
          this.diagnosisParams.attachmentInfoList = map(
              this.diagnosisParams.attachmentInfoList,
              item => {
                return extend({}, item, {fileSource: "DOCTOR"});
              }
          );
        }
      }
      let keys = {
        cbct: "cbct",
        other: "other_file",
        iTero: "iTero",
        local_upload: ["sharp_upjaw", "sharp_downjaw"]
      }[this.diagnosisParams.digitalModelFile];
      const otherPic = map(this.fileList, it => {
        return {
          nanoId: it.nanoId,
          ETag: it.ETag,
          degree: it.degree || 0,
          horizontal: it.horizontal || false,
          vertical: it.vertical || false
        };
      });
      this.diagnosisParams = {
        ...this.diagnosisParams,
        otherPicture: JSON.stringify(otherPic),
        attachmentInfoList: filter(
            this.diagnosisParams.attachmentInfoList,
            item =>
                (isArray(keys)
                    ? keys.includes(item.fileKey)
                    : item.fileKey === keys) || item.fileKey === "cbct"
        )
      };
      let resultObj = JSON.parse(JSON.stringify(this.diagnosisParams));
      resultObj["sideFacePicture"] =
          resultObj["sideFacePicture"] &&
          JSON.stringify(resultObj["sideFacePicture"]);
      resultObj["frontFacePicture"] =
          resultObj["frontFacePicture"] &&
          JSON.stringify(resultObj["frontFacePicture"]);
      resultObj["smilePicture"] =
          resultObj["smilePicture"] && JSON.stringify(resultObj["smilePicture"]);
      resultObj["anteriorOverjetPicture"] =
          resultObj["anteriorOverjetPicture"] &&
          JSON.stringify(resultObj["anteriorOverjetPicture"]);
      resultObj["upToothPicture"] =
          resultObj["upToothPicture"] &&
          JSON.stringify(resultObj["upToothPicture"]);
      resultObj["downToothPicture"] =
          resultObj["downToothPicture"] &&
          JSON.stringify(resultObj["downToothPicture"]);
      resultObj["mouthRightPicture"] =
          resultObj["mouthRightPicture"] &&
          JSON.stringify(resultObj["mouthRightPicture"]);
      resultObj["mouthFrontPicture"] =
          resultObj["mouthFrontPicture"] &&
          JSON.stringify(resultObj["mouthFrontPicture"]);
      resultObj["mouthLeftPicture"] =
          resultObj["mouthLeftPicture"] &&
          JSON.stringify(resultObj["mouthLeftPicture"]);
      resultObj["xrayCurvePicture"] =
          resultObj["xrayCurvePicture"] &&
          JSON.stringify(resultObj["xrayCurvePicture"]);
      resultObj["xraySidePicture"] =
          resultObj["xraySidePicture"] &&
          JSON.stringify(resultObj["xraySidePicture"]);
      resultObj["bitePicture"] =
          resultObj["bitePicture"] && JSON.stringify(resultObj["bitePicture"]);
      resultObj["openAndClosePicture"] =
          resultObj["openAndClosePicture"] &&
          JSON.stringify(resultObj["openAndClosePicture"]);

      if (this.diagnosisParams?.digitalModelFile !== 'more_sources') {
        resultObj.moreSources = ''
      } else {
        resultObj.moreSources = this.moreSources;
      }

      const submitData = await beforeSubmit(this.queryCurePlanId, 'image')
      resultObj = {...resultObj, ...submitData}

      this.isLoading = true;
      if (!this.diagnosisParams.id) {
        return createCurePlan(pickBy(resultObj))
            .then(data => {
              this.isLoading = false;
              this.diagnosisParams.id = data;
              notifyMsg(this, "success", this.$t("common.message.yzc"), 2500);
              changeRouteQuery(this, {curePlanId: data});
              sessionStorage.setItem(
                  "diagnosisParams",
                  JSON.stringify(resultObj)
              );
              return Promise.resolve();
            })
            .catch(() => {
              this.isLoading = false;
              this.$emit("saveError");
              return Promise.reject();
            });
      } else {
        return editCurePlan(pickBy(resultObj))
            .then(() => {
              this.isLoading = false;
              changeRouteQuery(this, {curePlanId: this.diagnosisParams.id});
              notifyMsg(this, "success", this.$t("common.message.yzc"), 2500);
              return Promise.resolve();
            })
            .catch(() => {
              this.isLoading = false;
              this.$emit("saveError");
              return Promise.reject();
            });
      }
    },
    clickSharpUpJaw(ref) {
      if (this.modeNoProblem) return;
      this.$refs[ref].$el.childNodes[0] &&
      this.$refs[ref].$el.childNodes[0].click();
    },
    getDetail() {
      let id = this.queryCurePlanId;
      if (id) {
        this.diagnosisParams.id = id;
        Promise.all([
          this.getCaseCureDetail({id}).then(obj => {
            this.moreSources = obj.moreSources;
            try {
              JSON.parse(obj.otherPicture);
              this.other_list = map(JSON.parse(obj.otherPicture), it => {
                let obj = it;
                if (!it.nanoId) {
                  it.nanoId = it.ETag;
                }
                this.fileList.push(obj);
                return {
                  url: it
                };
              });
            } catch (error) {
              const arr = obj.otherPicture ? obj.otherPicture.split(",") : [];
              this.other_file = map(arr, it => {
                this.fileList.push({ETag: it, nanoId: it});
                return {
                  url: it
                };
              });
            }
            this.diagnosisParams = {
              ...this.diagnosisParams,
              ...obj
            };
            sessionStorage.setItem(
                "diagnosisParams",
                JSON.stringify(this.diagnosisParams)
            );
            this.diagnosisParams["sideFacePicture"] = this.isJSON(
                this.diagnosisParams["sideFacePicture"]
            );
            this.diagnosisParams["frontFacePicture"] = this.isJSON(
                this.diagnosisParams["frontFacePicture"]
            );
            this.diagnosisParams["smilePicture"] = this.isJSON(
                this.diagnosisParams["smilePicture"]
            );
            this.diagnosisParams["upToothPicture"] = this.isJSON(
                this.diagnosisParams["upToothPicture"]
            );
            this.diagnosisParams["downToothPicture"] = this.isJSON(
                this.diagnosisParams["downToothPicture"]
            );
            this.diagnosisParams["mouthRightPicture"] = this.isJSON(
                this.diagnosisParams["mouthRightPicture"]
            );
            this.diagnosisParams["mouthFrontPicture"] = this.isJSON(
                this.diagnosisParams["mouthFrontPicture"]
            );
            this.diagnosisParams["mouthLeftPicture"] = this.isJSON(
                this.diagnosisParams["mouthLeftPicture"]
            );
            this.diagnosisParams["xrayCurvePicture"] = this.isJSON(
                this.diagnosisParams["xrayCurvePicture"]
            );
            this.diagnosisParams["xraySidePicture"] = this.isJSON(
                this.diagnosisParams["xraySidePicture"]
            );
            this.diagnosisParams["anteriorOverjetPicture"] = this.isJSON(
                this.diagnosisParams["anteriorOverjetPicture"]
            );
            this.diagnosisParams["bitePicture"] = this.isJSON(
                this.diagnosisParams["bitePicture"]
            );
            this.diagnosisParams["openAndClosePicture"] = this.isJSON(
                this.diagnosisParams["openAndClosePicture"]
            );
            const {
              attachmentList = [],
              caseInfo = {},
              sideFacePicture,
              frontFacePicture,
              smilePicture,
              upToothPicture,
              downToothPicture,
              mouthRightPicture,
              mouthFrontPicture,
              mouthLeftPicture,
              xrayCurvePicture,
              xraySidePicture,
              anteriorOverjetPicture,
              bitePicture,
              openAndClosePicture
            } = obj;
            this.caseNumber = caseInfo.caseNumber;
            this.carouselList = [
              sideFacePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(sideFacePicture).ETag,
                    filed: "sideFacePicture",
                    name:
                        this.$route.query.productType !== "F"
                            ? this.$t("cases.createImage.cmx")
                            : this.$t("cases.createImage.zcmwxx"),
                    ETag:
                        this.isJSON(sideFacePicture).ETag ||
                        this.isJSON(sideFacePicture).nanoId,
                    nanoId:
                        this.isJSON(sideFacePicture).nanoId ||
                        this.isJSON(sideFacePicture).ETag,
                    degree: this.isJSON(sideFacePicture).degree,
                    horizontal: this.isJSON(sideFacePicture).horizontal,
                    vertical: this.isJSON(sideFacePicture).vertical
                  }
                  : "",
              frontFacePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(frontFacePicture).ETag,
                    filed: "frontFacePicture",
                    name:
                        this.$route.query.productType !== "F"
                            ? this.$t("cases.createImage.zmx")
                            : this.$t("cases.createImage.zmwxx"),
                    ETag:
                        this.isJSON(frontFacePicture).ETag ||
                        this.isJSON(frontFacePicture).nanoId,
                    nanoId:
                        this.isJSON(frontFacePicture).nanoId ||
                        this.isJSON(frontFacePicture).ETag,
                    degree: this.isJSON(frontFacePicture).degree,
                    horizontal: this.isJSON(frontFacePicture).horizontal,
                    vertical: this.isJSON(frontFacePicture).vertical
                  }
                  : "",
              smilePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(smilePicture).ETag,
                    filed: "smilePicture",
                    name:
                        this.$route.query.productType !== "F"
                            ? this.$t("cases.createImage.wxx")
                            : this.$t("cases.createImage.ycmwxx"),
                    ETag:
                        this.isJSON(smilePicture).ETag ||
                        this.isJSON(smilePicture).nanoId,
                    nanoId:
                        this.isJSON(smilePicture).nanoId ||
                        this.isJSON(smilePicture).ETag,
                    degree: this.isJSON(smilePicture).degree,
                    horizontal: this.isJSON(smilePicture).horizontal,
                    vertical: this.isJSON(smilePicture).vertical
                  }
                  : "",
              upToothPicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(upToothPicture).ETag,
                    filed: "upToothPicture",
                    name: this.$t("cases.createImage.sylx"),
                    ETag:
                        this.isJSON(upToothPicture).ETag ||
                        this.isJSON(upToothPicture).nanoId,
                    nanoId:
                        this.isJSON(upToothPicture).nanoId ||
                        this.isJSON(upToothPicture).ETag,
                    degree: this.isJSON(upToothPicture).degree,
                    horizontal: this.isJSON(upToothPicture).horizontal,
                    vertical: this.isJSON(upToothPicture).vertical
                  }
                  : "",
              anteriorOverjetPicture
                  ? {
                    href:
                        this.$PicPrefix +
                        this.isJSON(anteriorOverjetPicture).ETag,
                    filed: "anteriorOverjetPicture",
                    name: this.$t("cases.createImage.qyfgx"),
                    ETag:
                        this.isJSON(anteriorOverjetPicture).ETag ||
                        this.isJSON(anteriorOverjetPicture).nanoId,
                    nanoId:
                        this.isJSON(anteriorOverjetPicture).nanoId ||
                        this.isJSON(anteriorOverjetPicture).ETag,
                    degree: this.isJSON(anteriorOverjetPicture).degree,
                    horizontal: this.isJSON(anteriorOverjetPicture).horizontal,
                    vertical: this.isJSON(anteriorOverjetPicture).vertical
                  }
                  : "",
              downToothPicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(downToothPicture).ETag,
                    filed: "downToothPicture",
                    name: this.$t("cases.createImage.xylx"),
                    ETag:
                        this.isJSON(downToothPicture).ETag ||
                        this.isJSON(downToothPicture).nanoId,
                    nanoId:
                        this.isJSON(downToothPicture).nanoId ||
                        this.isJSON(downToothPicture).ETag,
                    degree: this.isJSON(downToothPicture).degree,
                    horizontal: this.isJSON(downToothPicture).horizontal,
                    vertical: this.isJSON(downToothPicture).vertical
                  }
                  : "",
              mouthRightPicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(mouthRightPicture).ETag,
                    filed: "mouthRightPicture",
                    name: this.$t("cases.createImage.knzcyx"),
                    ETag:
                        this.isJSON(mouthRightPicture).ETag ||
                        this.isJSON(mouthRightPicture).nanoId,
                    nanoId:
                        this.isJSON(mouthRightPicture).nanoId ||
                        this.isJSON(mouthRightPicture).ETag,
                    degree: this.isJSON(mouthRightPicture).degree,
                    horizontal: this.isJSON(mouthRightPicture).horizontal,
                    vertical: this.isJSON(mouthRightPicture).vertical
                  }
                  : "",
              mouthFrontPicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(mouthFrontPicture).ETag,
                    filed: "mouthFrontPicture",
                    name: this.$t("cases.createImage.knzwx"),
                    ETag:
                        this.isJSON(mouthFrontPicture).ETag ||
                        this.isJSON(mouthFrontPicture).nanoId,
                    nanoId:
                        this.isJSON(mouthFrontPicture).nanoId ||
                        this.isJSON(mouthFrontPicture).ETag,
                    degree: this.isJSON(mouthFrontPicture).degree,
                    horizontal: this.isJSON(mouthFrontPicture).horizontal,
                    vertical: this.isJSON(mouthFrontPicture).vertical
                  }
                  : "",
              mouthLeftPicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(mouthLeftPicture).ETag,
                    filed: "mouthLeftPicture",
                    name: this.$t("cases.createImage.knycyx"),
                    ETag:
                        this.isJSON(mouthLeftPicture).ETag ||
                        this.isJSON(mouthLeftPicture).nanoId,
                    nanoId:
                        this.isJSON(mouthLeftPicture).nanoId ||
                        this.isJSON(mouthLeftPicture).ETag,
                    degree: this.isJSON(mouthLeftPicture).degree,
                    horizontal: this.isJSON(mouthLeftPicture).horizontal,
                    vertical: this.isJSON(mouthLeftPicture).vertical
                  }
                  : "",
              xrayCurvePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(xrayCurvePicture).ETag,
                    filed: "xrayCurvePicture",
                    name: this.$t("cases.createImage.dcp"),
                    ETag:
                        this.isJSON(xrayCurvePicture).ETag ||
                        this.isJSON(xrayCurvePicture).nanoId,
                    nanoId:
                        this.isJSON(xrayCurvePicture).nanoId ||
                        this.isJSON(xrayCurvePicture).ETag,
                    degree: this.isJSON(xrayCurvePicture).degree,
                    horizontal: this.isJSON(xrayCurvePicture).horizontal,
                    vertical: this.isJSON(xrayCurvePicture).vertical
                  }
                  : "",
              xraySidePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(xraySidePicture).ETag,
                    filed: "xraySidePicture",
                    name: this.$t("cases.createImage.dwp"),
                    ETag:
                        this.isJSON(xraySidePicture).ETag ||
                        this.isJSON(xraySidePicture).nanoId,
                    nanoId:
                        this.isJSON(xraySidePicture).nanoId ||
                        this.isJSON(xraySidePicture).ETag,
                    degree: this.isJSON(xraySidePicture).degree,
                    horizontal: this.isJSON(xraySidePicture).horizontal,
                    vertical: this.isJSON(xraySidePicture).vertical
                  }
                  : "",
              bitePicture
                  ? {
                    href: this.$PicPrefix + this.isJSON(bitePicture).ETag,
                    filed: "bitePicture",
                    name: this.$t("cases.createImage.yhx"),
                    ETag:
                        this.isJSON(bitePicture).ETag ||
                        this.isJSON(bitePicture).nanoId,
                    nanoId:
                        this.isJSON(bitePicture).nanoId ||
                        this.isJSON(bitePicture).ETag,
                    degree: this.isJSON(bitePicture).degree,
                    horizontal: this.isJSON(bitePicture).horizontal,
                    vertical: this.isJSON(bitePicture).vertical
                  }
                  : "",
              openAndClosePicture
                  ? {
                    href:
                        this.$PicPrefix + this.isJSON(openAndClosePicture).ETag,
                    filed: "openAndClosePicture",
                    name: this.$t("cases.createImage.khx"),
                    ETag:
                        this.isJSON(openAndClosePicture).ETag ||
                        this.isJSON(openAndClosePicture).nanoId,
                    nanoId:
                        this.isJSON(openAndClosePicture).nanoId ||
                        this.isJSON(openAndClosePicture).ETag,
                    degree: this.isJSON(openAndClosePicture).degree,
                    horizontal: this.isJSON(openAndClosePicture).horizontal,
                    vertical: this.isJSON(openAndClosePicture).vertical
                  }
                  : ""
            ].filter(item => !!item.href);
            this.carouselList = [
              ...this.carouselList,
              ...map(this.fileList, item => {
                return {
                  nanoId: item.nanoId || item.ETag,
                  href: this.$PicPrefix + item.ETag,
                  ETag: item.ETag,
                  filed: "otherPicture",
                  name: this.$t("cases.createImage.yxzl"),
                  degree: item.degree,
                  horizontal: item.horizontal,
                  vertical: item.vertical
                };
              })
            ];
            this.carouselList = map(this.carouselList, (item, index) => {
              return extend({}, item, {index: index + ""});
            });
            let otherIndexList = [];
            each(this.carouselList, (item, index) => {
              if (item.filed === "otherPicture") {
                otherIndexList.push(index);
              }
            });
            this.fileList = map(this.fileList, (item, index) => {
              return extend(
                  {},
                  {
                    nanoId: item.nanoId,
                    href: this.$PicPrefix + item.ETag,
                    index: otherIndexList[index] + "",
                    ETag: item.ETag,
                    text: this.$t("casesDetail.publicCases.casesPic.qtyx"),
                    degree: item.degree || 0,
                    horizontal: item.horizontal || false,
                    vertical: item.vertical || false
                  }
              );
            });
            this.isEditFileList = attachmentList;
            if (attachmentList) {
              this.diagnosisParams.attachmentInfoList = attachmentList;
            }
            attachmentList.forEach(item => {
              const obj = {
                name: item.fileName,
                url: `${this.$PicPrefix}${item.fileUrl}`,
                id: item.id
              };
              if (["other_file",].includes(item.fileKey)) {
                this.fileNameObj[item.fileKey].push({
                  name: item.fileName,
                  id: item.id,
                  realFileName: item.realFileName
                });
              } else {
                this.fileNameObj[item.fileKey] = item.realFileName;
              }
            });
          }),
          cureProblemList({
            caseId: this.diagnosisParams.caseId,
            curePlanId: id
          }).then(data => {
            const diagnosisProblem = {};
            data.forEach(item => {
              diagnosisProblem[item.groupName] = item.content;
            });

            this.diagnosisProblem = diagnosisProblem;
            this.problemList = data.filter(item =>
                problemDict?.picModalDict.includes(item.groupName)
            );
            let currentNumber = {
              A: 20,
              B: 22,
              C: 20,
              D: 4,
              E: 21,
              F: 17,
              G: 22,
              H: 22,
              I: 8
            }[this.$route.query.productType];
            if (
                this.$route.query.productType === "F" &&
                get(this.caseDetail, "nextStatus") === "to_resubmit"
            ) {
              this.modeNoProblem = some(data, item => +item.groupName === '牙颌模型');
              // const currentList = data.map(item => item.groupNo);
              // if (currentList.includes(currentNumber)) {
              //   this.modeNoProblem = false;
              // } else {
              //   this.modeNoProblem = true;
              // }
            } else {
              if (get(this.caseDetail, "nextStatus") === "to_resubmit") {
                let currentERR = some(data, item =>
                    problemDict?.picModalDict.includes(item.groupName)
                );
                this.modeNoProblem = currentERR
                    ? !currentERR
                    : data.length === 0
                        ? false
                        : !some(data, item => +item.groupName === '牙颌模型');
                if (data.every(item => item.groupName !== '牙颌模型')) {
                  this.modeNoProblem = true;
                }
              }
            }
            // if (this.$route.query.productType === "F") {
            //   this.modeNoProblem = false;
            // }
          })
        ]).then(() => {
          setTimeout(() => {
            this.isResponse = 0;
          }, 500);
        });
      }
    },
    getConfig() {
      getQiniuToken().then(data => {
        this.uploadToken = data;
      });
      getDictAllList(["silicone_rubber_model", "digital_model_file"])
          .then(data => {
            this.isLoading = false;
            let dictObj = {},
                diaKeyObj = {};
            data.forEach(item => {
              if (!dictObj[item.parentKey]) {
                dictObj[item.parentKey] = [item];
              } else {
                dictObj[item.parentKey].push(item);
              }
              diaKeyObj[item.key] = item.value;
            });
            this.diaKeyObj = diaKeyObj;
            this.dictObj = dictObj;
          })
          .catch(() => {
            this.isLoading = false;
          });
    }
  },
  components: {
    FullLoading,
    TheDelivery,
    ExBirdie,
    LookPic,
    PreviewImg
  },
  created() {
    setTimeout(() => {
      this.isLoading = true;
      this.isResponse += 1;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.diagnosisParams.caseId = this.queryCaseId;
      this.getHistoryFileList();
      this.getDictList();
      this.getDetail();
      this.getConfig();
      getDictList('more_sources').then((data) => {
        const _dict = {}
        this.MORE_LIST = data?.map(item => {
          _dict[item.key] = item.value
          return {
            label: item.value,
            value: item.key
          }
        })
        this.moreDict = _dict
      })
    }, 0)
  },
  mounted() {
    if (this.$refs.copyCases) {
      this.copyCases = new clipboard(this.$refs.copyCases);
    }
  }
};
</script>

<style lang="scss" scoped>
.current_img {
  position: fixed;
  bottom: 999rem;
  left: 999rem;
}

.other_img {
  margin-top: 0.1rem;
  display: flex;
  flex-flow: row wrap;

  .other_bc_img {
    width: 100%;
    background-image: url("/static/images/createCases/select.png");
    background-repeat: no-repeat;
    position: absolute;
    left: 0;
    top: 0.73rem;
    right: 0;
    height: 1rem;
    z-index: 9;
    background-size: 100% 100%;
  }

  .img_item {
    cursor: pointer;
    width: 3.44rem;
    height: 2.4rem;
    background-color: #f3f3f3;
    margin-right: 0.3rem;
    margin-bottom: 0.2rem;
    border-radius: 0.05rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    &:hover .icon {
      opacity: 1;
    }

    .img-content {
      position: relative;
      max-width: 100%;
      max-height: 100%;
    }

    .icon {
      width: 100%;
      height: 25%;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      transition: opacity 0.6s;

      .icon_font {
        font-size: 0.25rem;
        color: white;
        margin-right: 0.1rem;
      }
    }

    .delete_icon {
      width: 0.3rem;
      height: 0.3rem;
      background-image: url("/static/images/createCases/delet_img.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      cursor: pointer;
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
      z-index: 99;
    }
  }
}

.create_image {
  background-color: #fff;
  border-radius: 0.08rem;
  padding: 0 0.3rem 120px 0.3rem;
  color: #333;

  .dia_problem {
    width: 100%;
    background: #f4f4f4;
    padding: 10px 16px 30px;
    transform: translateY(30px);

    h5 {
      font-size: 0.22rem;
      color: $main_theme_color_333;
    }

    span {
      margin-right: 0.2rem;
    }

    .pro_box {
      word-break: break-all;
      font-size: 0.16rem;
      line-height: 0.3rem;
      color: $main_theme_color_333;
    }
  }

  .image_single {
    margin-bottom: 0.5rem;

    .image_single_header {
      display: flex;
      height: 0.58rem;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 10px;
    }

    .vertical_line {
      width: 4px;
      height: 26px;
    }

    .single_tit {
      font-size: 0.18rem;
      display: flex;
      align-items: center;

      .tit_icon {
        display: inline-block;
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 100%;
        background-image: url("/static/images/createCases/question.png");
        background-size: 100% 100%;
        margin-right: 0.06rem;
        margin-left: 0.16rem;
      }
    }

    .single_con {
      .problem_note {
        word-break: break-all;
        color: $main_theme_color;
        margin-bottom: 0.3rem;
        line-height: 0.22rem;
        font-size: 0.14rem;
      }

      .s_c_box {
        display: flex;
        margin-bottom: 30px;

        .s_c__left {
          min-width: 0.96rem;
          font-size: 0.16rem;
          color: $main_theme_color_333;
          display: flex;
          flex-flow: row-reverse;
          margin-top: 10px;
        }

        .s_c__right {
          position: relative;
          padding-left: 20px;

          .history_submit_btn {
            position: absolute;
            top: 0.1rem;
            right: -1rem;
            color: #409eff;
            cursor: pointer;
          }

          .s_c__tip {
            width: 4.36rem;
            height: 68px;
            padding: 0.16rem 0.2rem;
            background-color: #f4f4f4;
            border-radius: 4px;
            position: relative;
            display: flex;
            align-items: center;

            .tip_sp_icon {
              display: inline-block;
              width: 0.24rem;
              height: 0.24rem;
              background-image: url("../../../common/imgs/case/case_icon_plus.png");
              background-size: 100% 100%;
              cursor: pointer;
            }

            .s_c_fkd {
              margin-left: 50px;
              border: 0.01rem solid $main_theme_color;
              border-radius: 0.06rem;
              width: 1.16rem;
              height: 0.36rem;
              padding: 0 0.1rem;
              line-height: 0.5rem;
              color: $main_theme_color_333;
              background-color: $main_theme_color;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;

              .fkd_icon {
                display: inline-block;
                width: 0.24rem;
                height: 0.24rem;
                background-image: url("/static/images/createCases/pc_doc_shunfeng.png");
                background-size: 100% 100%;
                border-radius: 100%;
                margin-right: 0.04rem;
              }
            }
          }

          .s_c__up {
            display: flex;
            align-items: center;
            font-weight: normal;
            margin-bottom: 0.16rem;
            margin-top: 20px;

            .upload-file {
              margin: 0 0.2rem;
            }

            .up_load {
              display: inline-block;
              height: 0.36rem;
              line-height: 0.36rem;
              border-radius: 0.03rem;
              outline: none;
              padding-right: 0.4rem;
              margin-left: 10px;
              position: relative;
            }

            .up_icon {
              display: inline-block;
              width: 0.24rem;
              height: 0.24rem;
              background-image: url("/static/images/createCases/web_doc_upload.png");
              background-size: 100% 100%;
              cursor: pointer;
            }

            .up_file {
              display: flex;
              align-items: center;

              .up_status {
                color: #5cb6ff;
                margin-left: 0.1rem;
              }
            }

            .other_file {
              margin-bottom: 0.1rem;
            }
          }
        }
      }

      .s_c__r_box {
        display: flex;
        align-items: center;

        .s_c__sp {
          min-width: 1.1rem;
          font-size: 14px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $main_theme_color_333;
          padding: 8px 0.2rem;
          border: 0.01rem solid #c8c8c8;
          border-radius: 0.06rem;
          cursor: pointer;
          box-sizing: border-box;
          margin-right: 20px;
        }

        .s_c__sp_active {
          background-color: $main_theme_color !important;
          color: $main_theme_color_333 !important;
          border: 0.01rem solid $main_theme_color !important;
        }
      }

      .up_ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 0 30px;

        .up_li {
          text-align: center;
          width: 3.44rem;
          margin-bottom: 30px;
          margin-right: 95px;

          &:nth-child(3n + 3) {
            margin-right: 0px;
          }

          .up_load {
            background-color: #f0f0f0;
            width: 3.44rem;
            height: 2.4rem;
            border-radius: 0.06rem;
            position: relative;
            z-index: 99;

            .up_load_img {
              width: 100%;
              position: absolute;
              bottom: 0;
              right: 0;
              top: 0;
              z-index: 1;
              text-align: center;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;

              &:hover .pic_look {
                opacity: 1;
              }

              img {
                max-width: 100%;
                max-height: 100%;
              }

              .pic_look {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 0.5rem;
                background-color: rgba(0, 0, 0, 0.6);
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.16rem;
                opacity: 0;
                transition: opacity 0.6s;
                z-index: 999999;

                img {
                  width: 0.24rem;
                  height: 0.16rem;
                  margin-right: 0.1rem;
                }
              }
            }

            .remove_pic {
              position: absolute;
              right: 0.1rem;
              top: 0.1rem;
              width: 0.3rem;
              height: 0.3rem;
              z-index: 9;
              cursor: pointer;
              border-radius: 100%;
              background-size: 100% 100%;
              background-image: url("/static/images/createCases/delet_img.png");
            }

            .up_load_def {
              position: absolute;
              left: 0;
              top: 0.5rem;
              right: 0;
              height: 1rem;
              z-index: 9;
              background-size: 100% 100%;
            }

            .up_load_def1 {
              background-image: url("/static/images/createCases/side.png");
            }

            .up_load_def2 {
              background-image: url("/static/images/createCases/front.png");
            }

            .up_load_def3 {
              background-image: url("/static/images/createCases/smile.png");
            }

            .up_load_def4 {
              background-image: url("/static/images/createCases/top.png");
            }

            .up_load_def5 {
              background-image: url("/static/images/createCases/bottom.png");
            }

            .up_load_def6 {
              background-image: url("/static/images/createCases/right.png");
            }

            .up_load_def7 {
              background-image: url("/static/images/createCases/main.png");
            }

            .up_load_def8 {
              background-image: url("/static/images/createCases/left.png");
            }

            .up_load_def9 {
              background-image: url("/static/images/createCases/select.png");
              background-repeat: no-repeat;
            }

            .up_load_def10 {
              background-image: url("/static/images/createCases/qyfgx.png");
              background-repeat: no-repeat;
            }

            .up_load_def11 {
              width: 92px;
              height: 52px;
              left: 50%;
              top: 82px;
              transform: translateX(-50%);
              background-image: url("/static/images/createCases/yhx.png");
              background-repeat: no-repeat;
            }

            .up_load_def12 {
              width: 74px;
              height: 67px;
              left: 50%;
              top: 73px;
              transform: translateX(-50%);
              background-image: url("/static/images/createCases/khx.png");
              background-repeat: no-repeat;
            }
          }
        }

        .up_txt {
          font-size: 16px;
          color: $main_theme_color_333;
          margin-top: 0.1rem;

          span {
            color: $main_theme_color;
          }
        }
      }
    }
  }

  .carousel_option {
    margin-top: 0.25rem;
    padding-bottom: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .o_m {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      margin-right: 0.6rem;

      &:last-child {
        margin-right: 0;
      }

      img {
        width: 0.24rem;
        height: 0.24rem;
        margin-bottom: 0.05rem;
      }

      span {
        color: #999999;
        font-size: 0.16rem;
      }
    }
  }
}

.up_box {
  width: 3.44rem;
  height: 2.4rem;
  position: relative;
  background: #f0f0f0;

  .up_box_tip {
    width: 100%;
    position: absolute;
    bottom: 0.26rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: $main_theme_color_333;

    .up___tip_icon {
      display: inline-block;
      width: 0.25rem;
      height: 0.25rem;
      background-size: 100% 100%;
      background-image: url("/static/images/createCases/add_upload_img.png");
      border-radius: 100%;
      margin-right: 0.1rem;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.cancel_btn,
.sure_btn {
  width: 96px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
}

.cancel_btn {
  border: 1px solid #bbbbbb;
  margin-right: 32px;
}

.sure_btn {
  background: #fcc80e;
}

.download_btn {
  color: #fcc80e;
  font-size: 15px;
  cursor: pointer;
}

.disabled_btn {
  color: #cbcbcb;
}

.disabled_btn_two {
  opacity: 0.6;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.more_sources {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 80%;
  gap: 10px;

  .file_item {
    text-align: center;
    font-size: 14px;
    min-width: 100px;
    padding: 10px 5px;
    border: 1px solid #c8c8c8;
    border-radius: 6px;
    cursor: pointer;
  }

  .file_item:hover {
    border-color: $main_theme_color;
    transition: all 0.3s;
  }

  .file_item_active {
    background-color: $main_theme_color;
    transition: all 0.3s;
    border-color: $main_theme_color;
  }
}

.more-tip-text {
  color: $main_theme_color;
  font-size: 13px;
}

.more-tip {
  margin-top: 10px;
  font-size: 13px;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 6px rgba(85, 85, 85, 0.462745098039216);
}

.upload-cbct {
  width: 400px;
  height: 150px;
  margin-left: 10px !important;

  ::v-deep .el-upload-dragger {
    width: 400px !important;
    height: 150px !important;
    border-color: $main_theme_color !important;

    .upload-text {
      color: #333 !important;
    }
  }

  ::v-deep .el-upload--text {
    margin-bottom: 10px;
  }

  i {
    margin: 0 !important;
    font-size: 30px !important;
  }

  .el-upload__tip {
    font-size: 14px;
    color: #999 !important;
    line-height: 16px;

    .icon_success {
      font-size: 14px !important;
      color: #5cb6ff !important;
    }

    .icon_error {
      font-size: 14px !important;
      color: #fd7c08 !important;
    }
  }


  .el-upload__tip:last-child {
    font-size: 12px !important;
  }
}

.modal_header {
  width: 100%;
  display: flex;
  position: relative;
  padding-left: 20px;

  .title {
    font-size: 18px !important;
    color: #333;
  }

  .el-icon-close {
    position: absolute;
    right: 10px;
    top: -5px;
    font-size: 24px;
    font-weight: 800;
    cursor: pointer;
    color: #9e9999;
    transition: 0.2s all;
  }

  .el-icon-close:hover {
    color: #fcc80e;
    transition: 0.2s all;
  }
}

.status_modal {
  border-radius: 8px;
}

::v-deep .status_modal .el-dialog__header {
  padding-left: 0 !important;
  padding-right: 0 !important;
  border-bottom: 1px solid #e5e5e5;
}

::v-deep .status_modal .el-dialog__body {
  padding: 0;
  max-height: 470px;
  overflow-y: auto;
}

::v-deep .status_modal .el-dialog__footer {
  padding: 0;
}

.status_modal .dialog-footer {
  box-shadow: 0px -2px 8px 0px rgba(51, 51, 51, 0.08);
  justify-content: center !important;
  padding-top: 10px;
  padding-bottom: 10px;

  > div {
    cursor: pointer !important;
  }

}

.disable_more {
  pointer-events: none;
  cursor: not-allowed
}

.upload_text {
  width: 400px !important;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  align-items: center;
  cursor: pointer;
  padding: 2px;
  border-radius: 6px;


  span {
    color: #67c23a;
  }

  .el-icon-close {
    display: none;
    font-size: 16px !important;
    color: #5cb6ff !important;
  }
}

.upload_text:hover {
  background-color: #f2f5f9;
  color: $main_theme_color;
  transition: all 0.2s;

  .el-icon-close {
    display: block;
  }

  .icon_success {
    display: none;
  }

}

.progress-wrap {
  > div {
    display: flex !important;
    align-items: center;
  }
}
</style>
